$(function() {
  function initProductsSlider($elem) {
      var $slider = $elem;

      $slider.on('init', function(event, slick, direction) {
          $slider.css("opacity", 1);
          // $slider.find(".app-ch-shop-slider_prev").hide(0);
      });

      $slider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
          var slidesToShow = slick.options.slidesToShow,
            $prev = $slider.find(".app-ch-shop-slider_prev"),
            $next = $slider.find(".app-ch-shop-slider_next");
        
          if (slick.options.responsive) {
            slick.options.responsive.forEach(function(elem){
              if (elem.breakpoint > $(window).width() && elem.settings.slidesToShow) {
                slidesToShow = elem.settings.slidesToShow;
              }
            });
          }
        
          var calc = ((nextSlide) / (slick.slideCount - slidesToShow)) * 100;

          if ($slider.next().hasClass("app-h-progress-wrapper")) {
              $slider.next().find(".app-h-progress").css('background-size', calc + '% 100%')
                  .attr('aria-valuenow', calc);
              $slider.next().find(".app-h-progress__label").text(calc + '% completed');
          }
          
          $slider.find(".app-ch-shop-slider_prev").css("opacity", 1);
          // if (nextSlide) {
          //   $prev.show(0);
          // } else {
          //   $prev.hide(0);
          // }
          // if ((slick.slideCount - slidesToShow) <= nextSlide) {
          //   $next.hide(0);
          // } else {
          //   $next.show(0);
          // }
      });

      $slider.slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: false,
          arrows: true,
          // infinite: false,
          prevArrow: '<button class="app-ch-shop-slider_prev" aria-label="Previous" type="button" style="display: block;"><i class="app-ch-arrow-icon app-ch-arrow-icon_prev"></i>Previous</button>',
          nextArrow: '<button class="app-ch-shop-slider_next" aria-label="Next" type="button" style="display: block;"><i class="app-ch-arrow-icon app-ch-arrow-icon_next">Next</button>',
          lazyLoad: 'ondemand',
          responsive: [{
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: true
                  }
              },
              {
                  breakpoint: 500,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      arrows: false
                  }
              }
          ]
      });
  }
  
  function init() {
    if (window.vwo416) {
      $(".vwo-416-container").hide(0);
      $(".carousel-vwo-container").css('display', 'block');
      initProductsSlider($(".app-h-product-slider-1"));
      initProductsSlider($(".app-h-product-slider-2"));
      initProductsSlider($(".app-h-product-slider-3"));
      initProductsSlider($(".app-h-product-slider-4"));
      initProductsSlider($(".app-h-product-slider-5"));
      initProductsSlider($(".app-h-product-slider-6"));
    } else {
      $(".carousel-vwo-container").remove();
    }
  }

  init();
});